import cloneDeep from 'lodash.clonedeep';
import { PHOTO_ATTRIBUTES } from '../constants/photo-attributes';

export function clonePhotoWithoutEdits(sourcePhoto) {
  const clonedPhoto = cloneDeep(sourcePhoto);

  PHOTO_ATTRIBUTES.forEach((key) => {
    delete clonedPhoto[key];
  });

  return clonedPhoto;
}
